import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Modal from '@components/styled-UI/Modal';

import PreLoader from '@images/svg-icons/preLoader.svg';

import { RootState } from 'src/store/reducers';

import * as actions from '@redux-actions/';

import { getDoctorInfo } from '@services/myAppointmentServices';
import clsx from 'clsx';

interface Props {
    isOpenDoctorInfoModal?: boolean;
    onCloseModal?: () => void;
    storeNumber: string;
    doctorId: number;
}

const EyeExamDoctorInfoModal = ({
    isOpenDoctorInfoModal = false,
    onCloseModal,
    storeNumber,
    doctorId,
}: Props): JSX.Element => {
    const config = useSelector((state: RootState) => state.common.config);
    const getDoctorInfoRequestStatus = useSelector(
        (state: RootState) => state.myAppointment.getDoctorInfoRequestStatus
    );
    const doctorInfo = useSelector((state: RootState) => state.myAppointment.doctor);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            getDoctorInfo(
                config.mockRequest,
                config.storeId,
                storeNumber.toString(),
                doctorId.toString()
            )
        );
        return () => {
            dispatch(actions.getDoctorInfoPending());
        };
    }, []);

    return (
        <Modal
            isOpen={isOpenDoctorInfoModal}
            close={onCloseModal}
            isCentered
            customStyle="eye-exams-form-modal-sm"
        >
            <div className="eye-exams-doctor-info-modal">
                {getDoctorInfoRequestStatus === 'IDLE' && <PreLoader />}

                {getDoctorInfoRequestStatus === 'ERROR' && (
                    <div>Could not fetch Doctor's details</div>
                )}

                {getDoctorInfoRequestStatus === 'SUCCESS' && (
                    <>
                        <div className="doctor-photo-container" >
                            <img className={"doctor-photo " +  ((doctorInfo.photo === undefined || doctorInfo.photo === '') ? 'hidden' : '')} src={doctorInfo.photo} />
                        </div>

                        <div className="doctor-info">
                            <div className="doctor-info-name">
                                Dr. {doctorInfo.firstName} {doctorInfo.lastName}
                            </div>

                            <div className={"doctor-info-table"}>
                                <div className={"doctor-info-table-label "  + ((doctorInfo.languages === undefined || doctorInfo.languages === '') ? 'hidden' : '') }>Speaks:</div>
                                <div className={clsx(
                                    'doctor-info-table-data',
                                    { 'long-text': doctorInfo.languages?.length >= 20 },
                                    { 'hidden': doctorInfo.languages === undefined || doctorInfo.languages === '' }
                                )} >
                                    {doctorInfo.languages?.join(', ')}
                                </div>

                                <div className={"doctor-info-table-label "  + ((doctorInfo.gender === undefined || doctorInfo.gender === '') ? 'hidden' : '') }>Gender:</div>
                                <div className={clsx(                                    
                                    'doctor-info-table-data',
                                    { 'long-text': doctorInfo.gender?.length >= 20 },
                                    { 'hidden': doctorInfo.gender === undefined || doctorInfo.gender === '' }
                                )} >
                                    {doctorInfo.gender}
                                </div>
                                
                                <div className={"doctor-info-table-label "  + ((doctorInfo.education === undefined || doctorInfo.education === '') ? 'hidden' : '') }>Education:</div>
                                <div className={clsx(
                                    'doctor-info-table-data education',
                                    { 'long-text': doctorInfo.education?.length >= 20 },
                                    { 'hidden': doctorInfo.education === undefined || doctorInfo.education === '' }
                                )} >
                                    {doctorInfo.education}
                                </div>

                                <div className={"doctor-info-table-label "  + ((doctorInfo.licenseDegree === undefined || doctorInfo.licenseDegree === '') ? 'hidden' : '') }>License:</div>
                                <div className={clsx(
                                    'doctor-info-table-data license',
                                    { 'long-text': doctorInfo.licenseDegree.length >= 20 },
                                    { 'hidden': doctorInfo.licenseDegree === undefined || doctorInfo.licenseDegree === '' }
                                )} >
                                    {doctorInfo.licenseDegree}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};
export default EyeExamDoctorInfoModal;
